import { createAction, props } from '@ngrx/store';
import { dashboard, dashboardOwner, gridItem } from 'src/app/models';
import { dashboardConfig } from '../models';


export const loadDashboards = createAction(
  '[Dashboard Page] Load Dashboards'
);

export const loadDashboardConfig = createAction(
  '[Dashboard Page] Load Dashboards Config'
);

export const saveDashboards = createAction(
  '[Dashboard Page] Save Dashboards'
);

export const handleExportedDashboard = createAction(
  '[Dashboard Page] Export Dashboards',
  props<{ exportedDashboardData: any }>()
);

export const removeDashboard = createAction(
  '[Dashboard Page] Remove Dashboard',
  props<{ dashboard: dashboard }>()
);

export const addDashboard = createAction(
  '[Dashboard Page] Create Product',
  props<{ dashboard: dashboard }>()
);

export const ClearCurrentDashboard = createAction(
  '[Dashboard Page] Clear Current Dashboard'
);

export const selectDashboard = createAction(
  '[Dashboard Page] Update Name Dashboard',
  props<{ dashboard: dashboard }>()
);

export const updateDashboardName = createAction(
  '[Dashboard Page] set Dashboard Name',
  props<{ dashboard: dashboard, newName: string }>()
);

export const updateDashboardAccess = createAction(
  '[Dashboard Page] set Dashboard Access',
  props<{ dashboard: dashboard, isPublic: boolean }>()
);

export const updateDashboardOwner = createAction(
  '[Dashboard Page] set Dashboard New Owner',
  props<{ dashboard: dashboard, owner: dashboardOwner }>()
)

export const updateDashboardAllowNonOwnersToEdit = createAction(
  '[Dashboard Page] set Dashboard "Allow Non Owners To Edit"',
  props<{ dashboard: dashboard, allowOthersToEdit: boolean }>()
);

export const addWidget = createAction(
  '[Dashboard Page] Add Widget',
  props<{ gridItem: gridItem }>()
);

export const updateWidget = createAction(
  '[Dashboard Page] Update Widget',
  props<{ gridItem: gridItem }>()
);

export const removeWidget = createAction(
  '[Dashboard Page] Remove Widget',
  props<{ gridItem: gridItem }>()
);

export const loadDashboardById = createAction(
  '[Dashboard Page] Load Dashboard By Id',
  props<{ dashboarIds: number[] }>()
);

export const updateDashboardSettings = createAction(
  '[Dashboard Page] Update Dashboard Settings',
  props<{ dashboars: dashboard[] }>()
);

//Api actions
export const loadDashboardSuccess = createAction(
  '[Dashboard API] Load Success',
  props<{ dashboards: dashboard[] }>()
);

export const loadDashboardByIdSuccess = createAction(
  '[Dashboard API] Load Dashboard By Id Success',
  props<{ dashboards: dashboard[] }>()
);

export const loadDashboardConfigSuccess = createAction(
  '[Dashboard API] Load Config Success',
  props<{ config: dashboardConfig }>()
);


export const saveDashboardSuccess = createAction(
  '[Dashboard API] Save Success',
  props<{ dashboards: dashboard[] }>()
);

export const loadFailure = createAction(
  '[Dashboard API] Load Fail',
  props<{ error: string }>()
);
